import cx from 'classnames';
import type { FunctionComponent, ReactNode } from 'react';

import { icons } from './Icon';
import GreenCheck from './Icon/GreenCheck';
import TooltipIcon from './TooltipIcon';
import type { TooltipPlacement } from './Tooltip';

import css from './LabeledCheckmark.module.less';

type Props = {
  label: ReactNode;
  id?: string;
  tooltip?: string;
  tooltipPlacement?: TooltipPlacement;
  testId?: string;
  className?: string;
};

/**
 * A display-only checkmark indicator with a label and an optional tooltip.
 * Unlike LabeledCheckbox, this is not an interactive form control — it statically
 * indicates that an option is included (e.g. pre-set options in a standard report).
 */
const LabeledCheckmark: FunctionComponent<Props> = ({
  label,
  id,
  tooltip,
  tooltipPlacement,
  testId,
  className,
}) => (
  <div className={cx(css.root, className)} data-testid={testId}>
    <GreenCheck />
    <span className={css.label}>{label}</span>
    {tooltip && (
      <span className={css.tooltip}>
        <TooltipIcon
          id={`tooltip-${id || ''}`}
          icon={icons.questionCircleO}
          tooltip={tooltip}
          placement={tooltipPlacement}
          testId={`tooltip-${id || ''}`}
        />
      </span>
    )}
  </div>
);

export default LabeledCheckmark;
